import { useState } from 'react'; //تستخدم لاكواد الجافاسكريبت
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';

function Fa({ question, answer }) {
  const [isAnswershowing,setanswer] = useState(false)
  return (
    <article className="faq" onClick={() => setanswer(prev => !prev)}>
      <div>
        <h4>{question}</h4>
        <button className="faq_icon">
          {
            isAnswershowing? <AiOutlineMinus/> : <AiOutlinePlus/>
          }
        </button>
      </div>
      {isAnswershowing && <p>{answer}</p>}
    </article>
  );
}

export default Fa;